
import React from 'react';
import PricingPlan from './PricingPlan';

interface PricingPlansProps {
  isProcessing: string | null;
  onSelectPlan: (plan: 'monthly' | 'annual' | 'lifetime') => void;
}

const PricingPlans = ({ isProcessing, onSelectPlan }: PricingPlansProps) => {
  return (
    <div className="grid grid-cols-1 gap-8 md:grid-cols-3 animate-slide-up [animation-delay:300ms] opacity-0">
      <PricingPlan 
        type="monthly"
        isProcessing={isProcessing}
        onSelectPlan={onSelectPlan}
        popular={false}
      />
      <PricingPlan 
        type="annual"
        isProcessing={isProcessing}
        onSelectPlan={onSelectPlan}
        popular={true}
      />
      <PricingPlan 
        type="lifetime"
        isProcessing={isProcessing}
        onSelectPlan={onSelectPlan}
        popular={false}
      />
    </div>
  );
};

export default PricingPlans;
